import React from 'react'
import { connect } from 'react-redux'
import { Button, Form, Grid, Header, Image, Message, Segment, Loader } from 'semantic-ui-react'
import _ from 'lodash'

import { login } from '../redux/actions'

class SignIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: ''
        }
    
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
      }
    
      handleChange(event) {
          //console.log
        this.setState({[event.target.name]: event.target.value})
      }
    
      handleSubmit(event) {
        this.props.login(this.state)
        event.preventDefault()
      }


    render() {

        //console.log("state: ",this.props.user)
        const { error, loading_user } = this.props.user
        let showError = ''
        if (!_.isEmpty(error)){
            showError = 
                <Message negative>
                    <Message.Header>{error.message}</Message.Header>
                </Message>
        }
        return (
            <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 450 }}>
                    <Header as='h2' textAlign='center'>
                        <Image src='/ph_app_icon.png' />
                        <br /><br />
                        Administrator Login
                    </Header>
                    <Form size='large' onSubmit={this.handleSubmit}>
                        <Segment stacked>
                            <Form.Input 
                                fluid 
                                name='email'
                                icon='user' 
                                iconPosition='left' 
                                placeholder='E-mail address' 
                                value={this.state.email}
                                onChange={this.handleChange}
                            />
                            <Form.Input
                                fluid
                                name='password'
                                icon='lock'
                                iconPosition='left'
                                placeholder='Password'
                                type='password'
                                value={this.state.password}
                                onChange={this.handleChange}
                            />

                            <Button primary fluid size='large' loading={loading_user}>
                                Login
                            </Button>
                        </Segment>
                    </Form>
                    {showError}
                    <Message>
                        <a href='#'>Forgot Password?</a>
                    </Message>
                </Grid.Column>
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    const { user } = state
    return { user }
}

export default connect(mapStateToProps, {login})(SignIn)